import React from 'react';

const Reject = props => {

    return (
        <div className="container g-pt-140 g-pb-50">
            <div className="u-heading-v3-1 g-pt-20">
                <h2 className="h3 u-heading-v3__title g-brd-primary g-brd-bottom-2--md g-font-size-22 g-font-weight-600 g-line-height-0_7">이메일 무단수집 거부</h2>
                <ul className="u-list-inline pull-right g-pt-2 g-font-size-13">
                    <li className="list-inline-item g-mr-5"><a className="u-link-v5 g-color-main" href="/">Home</a> <i className="g-color-gray-light-v2 g-ml-5">/</i></li>
                    <li className="list-inline-item g-color-primary"><span>이메일 무단수집 거부</span></li>
                </ul>
            </div>
            <p className="g-pt-30">웹사이트에 게시된 이메일 주소가 전자우편 수집 프로그램이나 그 밖의 기술적 장치를 이용하여 무단으로 수집되는 것을 거부하며, 이를 위반 시 정보통신망법에 의해 형사 처벌됨을 유념하시기 바랍니다. </p>
            <p className="g-pb-30">이메일을 기술적 장치를 사용하여 무단으로 수집, 판매,유통하거나 이를 이용한 자는「정보통신망이용촉진 및 정보보호 등에 관한 법률」제50조의 2 규정에 의하여 1천만원 이하의 벌금형에 처해집니다.</p>
        </div>

    )
}

export default Reject;


// WEBPACK FOOTER //
// ./src/pages/front/policy/reject.js